module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_f_normal.654109b0.png";